import { LegalDocumentPage } from "components/LegalDocumentPage";
import {
  investorEligibilityMeta,
  investorEligibilityIntro,
  investorEligibilitySections,
} from "content/investorEligibilityContent";

export default function InvestorAgreementPage() {
  return (
    <LegalDocumentPage
      meta={investorEligibilityMeta}
      intro={investorEligibilityIntro}
      sections={investorEligibilitySections}
      helmetDescription="Investor overview and eligibility requirements for investing on the Fortify start-up crowdfunding platform under NI 45-110."
    />
  );
}
